import { isErrorLogJsonBlobWithinLimit } from 'utils/error-log/is-error-log-json-blob-within-limit';

export function capErrorLogBlob<T>(value: T, fallback: T): T {
  return isErrorLogJsonBlobWithinLimit(value) ? value : fallback;
}
